import http from "@/api/http.js";

function listByStartTimeAndEndTime(startTime, endTime) {
  return http({
    url: "/HmsCheckinVisitor/ListByStartTimeAndEndTime",
    method: "get",
    params: {
      startTime: startTime,
      endTime: endTime,
    },
  });
}

function deleteById(id) {
  return http({
    url: "/HmsCheckinVisitor/DeleteById/" + id,
    method: "post"
  });
}

export default {
  listByStartTimeAndEndTime,
  deleteById
};
